export default __webpack_public_path__ + "static/media/getting-started.42ee513f.png";